<!--  -->
<template>
    <el-dialog class="add-edit-dialog"
               :title="type + '配置'"
               :visible="dialogVisible"
               @close="resetForm"
               width="640px">
        <el-form ref="formRef"
                 :model="form"
                 label-position="right"
                 :rules="rules"
                 label-width="70px">
            <el-form-item label="客户编号"
                          prop="customerCode">
                <el-input v-model="form.customerCode"
                          disabled
                          placeholder="请输入客户编号"></el-input>
            </el-form-item>
            <el-form-item label="客户名称"
                          prop="customerName">
                <advance-dialog v-model="form.customerName"
                                :params="customerParams"
                                :mValue="form.customerName"
                                @getAdvanceValue="getAdvanceValue">
                </advance-dialog>
            </el-form-item>
            <el-form-item label="仓库名称">
                <advance-dialog v-model="form.whName"
                                :params="whCodeParams"
                                :disabled="type==='修改'"
                                :mValue="form.whName"
                                ref="otpAdvanceRef"
                                @getAdvanceValue="getAdvanceValue">
                </advance-dialog>
            </el-form-item>
            <el-form-item label="订单类型">
                <el-card class="box-card">
                    <div slot="header">
                        <el-checkbox size="small"
                                     v-model="allChecked"
                                     @change="allChange">一键全选
                        </el-checkbox>
                    </div>
                    <el-checkbox-group v-model="form.orderType"
                                       @change="orderTypeChange">
                        <el-row>
                            <el-col :span="6"
                                    v-for="(item,index) in dictData.ORDER_TYPE_NEW"
                                    :key="index">
                                <el-checkbox size="small"
                                             :label="item.value">
                                    {{item.label}}
                                </el-checkbox>
                            </el-col>
                        </el-row>
                    </el-checkbox-group>
                </el-card>
            </el-form-item>
            <el-form-item label="生效时间"
                          prop="activeTime">
                <el-date-picker v-model="form.activeTime"
                                type="datetime"
                                placeholder="选择日期时间">
                </el-date-picker>
                <span style="margin-left: 15px;">默认0点生效</span>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button type="text"
                       @click="resetForm">取消</el-button>
            <el-button type="primary"
                       @click="saveForm"
                       :loading="btnLoading">
                保存
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import advanceDialog from '@/components/lots/otpAdvance';
import {
    getStrategyAdd,
    getStrategyUpdate
} from '../../../api/operationManagementStrategy.js';
import dayjs from 'dayjs';
export default {
    components: {
        advanceDialog
    },
    props: {
        dictData: {
            type: Object,
            default: () => {
                return [];
            }
        }
    },
    data () {
        return {
            type: '新增',
            dialogVisible: false,
            btnLoading: false,
            allChecked: false,
            detailData: [],
            orderTypeList: this.dictData,
            form: {
                customerCode: '', // 客户编号
                customerName: '', // 客户名称
                whCode: '', // 客户名称
                whName: '', // 客户名称
                orderType: [], // 订单类型
                activeTime: '' // 生效时间
            },
            rules: {
                customerCode: [
                    { required: true, message: '请输入客户编号', trigger: 'blur' }
                ],
                customerName: [
                    { required: true, message: '请选择客户名称', trigger: 'change' }
                ],
                // whName: [
                //     { required: true, message: '请选择仓库名称', trigger: 'change' }
                // ],
                activeTime: [
                    { required: true, message: '请选择生效时间', trigger: 'change' }
                ]
            },
            customerParams: {
                name: '客户',
                value: 'customerName',
                unfold: true,
                span: 4,
                type: 'advance',
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                ],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName']
            },
            whCodeParams: {
                name: '请选择仓库名称',
                value: 'whName',
                type: 'advance',
                span: 4,
                unfold: true,
                advanceConfig: [
                    { prop: 'whName', value: '仓库名称' },
                    { prop: 'whCode', value: '仓库编码' }
                ],
                tableConfig: [
                    { prop: 'whName', value: '仓库名称' },
                    { prop: 'whCode', value: '仓库编码' },
                    { prop: 'whStatus', value: '状态', type: 'select', options: { 0: '新增', 1: '合格', 2: '停用' } } // 0 - 新增, 1 - 合格, 2 - 停用;
                ],
                prefix: '/api-dc',
                advanceUrl: '/supplier/physics/warehouse/page?enableTenant=0', // 查询物理仓接口
                cbParams: ['whCode', 'whName', 'addressCode', 'whStatus']
            }
        };
    },
    created () {
    },
    mounted () { },
    methods: {
        resetForm () {
            this.form.customerCode = '';
            this.form.customerName = '';
            this.form.whCode = '';
            this.form.whName = '';
            this.form.activeTime = '';
            this.form.orderType = [];
            this.allChecked = false;
            this.dialogVisible = false;
        },
        saveForm () {
            const { validate } = this.$refs.formRef;
            validate(valid => {
                if (!valid) return;
                const obj = JSON.parse(JSON.stringify(this.form));
                obj.orderType = obj.orderType.join(',');
                obj.activeTime = dayjs(new Date(obj.activeTime).getTime()).format('YYYY-MM-DD HH:mm:ss');
                const orderTypeList = [];
                this.form.orderType.forEach(e => {
                    let name = '';
                    this.dictData.ORDER_TYPE_NEW.forEach(e1 => {
                        if (e1.value === e) {
                            name = e1.label;
                        }
                    });
                    const obj1 = {
                        customerCode: this.form.customerCode,
                        whCode: this.form.whCode,
                        orderTypeCode: e,
                        orderTypeName: name
                    };
                    orderTypeList.push(obj1);
                });
                obj.orderTypeList = orderTypeList;
                this.btnLoading = true;
                if (this.type === '新增') {
                    getStrategyAdd(obj)
                        .then((res) => {
                            if (res && +res.code === 0) {
                                this.$message.success('新增成功');
                                this.resetForm();
                                this.dialogVisible = false;
                                this.$emit('uploadTableList');
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    obj.id = this.detailData.id;
                    obj.orderTypeList = obj.orderTypeList.filter(item => {
                        return item.orderTypeName;
                    });
                    getStrategyUpdate(obj)
                        .then((res) => {
                            if (res && +res.code === 0) {
                                this.$message.success('修改成功');
                                this.resetForm();
                                this.dialogVisible = false;
                                this.$emit('uploadTableList');
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        getAdvanceValue (data) {
            if (+data.whStatus === 2) {
                this.$refs.otpAdvanceRef.value = '';
                return this.$message.warning('请选择状态未合格和新增的仓库');
            }
            this.form = {
                ...this.form,
                ...data
            };
        },
        // 清空表单
        resetFieldsFn () {

        },
        // 全选反选
        allChange (value) {
            if (value) {
                const arr = [];
                this.orderTypeList.ORDER_TYPE_NEW.forEach(e => arr.push(e.value));
                this.form.orderType = arr;
            } else {
                this.form.orderType = [];
            }
        },
        // 订单类型选择
        orderTypeChange (value) {
            value.length === this.orderTypeList.ORDER_TYPE_NEW.length ? this.allChecked = true : this.allChecked = false;
        },
        // 回显
        detailDataFn (data) {
            const { customerCode, customerName, whCode, whName, activeTime } = data;
            this.form.customerCode = customerCode;
            this.form.customerName = customerName;
            this.form.whCode = whCode;
            this.form.whName = whName;
            this.form.activeTime = activeTime;
            this.detailData = data;
            data.orderTypeList.forEach(e => {
                this.form.orderType.push(e.orderTypeCode);
            });
            if (data.orderTypeList.length === this.dictData.ORDER_TYPE_NEW.length) this.allChecked = true;
        }
    }

};
</script>
<style lang='less'>
.add-edit-dialog {
    .el-form-item__content .el-input-group {
        vertical-align: middle;
    }
    .el-date-editor--datetimerange.el-input__inner {
        width: 100%;
    }
    .el-card__header {
        padding: 5px 10px;
        div {
            line-height: normal;
        }
    }
    .el-card.is-always-shadow {
        box-shadow: unset;
    }
    // .el-checkbox {
    //     display: flex;
    //     align-items: center;
    //     height: 30px;
    // }
    // .el-checkbox__label {
    //     display: inline-block;
    //     width: 95px;
    //     overflow: hidden;
    // }
}
</style>